/**
 * List icons.
 *
 * The phone stores a list's icon as an Ionicons name; the web has no Ionicons,
 * so it draws emoji. Rather than migrate the stored values -- which would break
 * the phone -- each name maps to the nearest emoji at render time, and anything
 * already an emoji is passed straight through.
 *
 * EMOJI_OPTIONS is what the picker offers, matching the phone's list exactly so
 * a list created on either platform looks the same on both.
 */

export const EMOJI_OPTIONS = [
  '📋', '📝', '✅', '🛒', '🎯', '💡', '📚', '🏠',
  '💼', '🎉', '🏋️', '🍽️', '✈️', '🎵', '🎮', '❤️',
  '⭐', '🔥', '🌟', '🚀', '💰', '🎁', '📦', '🔧',
];

export const ICON_TO_EMOJI: Record<string, string> = {
  'list-outline': '📋', 'list': '📋',
  'cart-outline': '🛒', 'cart': '🛒',
  'home-outline': '🏠', 'home': '🏠',
  'briefcase-outline': '💼', 'briefcase': '💼',
  'book-outline': '📚', 'book': '📚',
  'heart-outline': '❤️', 'heart': '❤️',
  'star-outline': '⭐', 'star': '⭐',
  'flame-outline': '🔥', 'flame': '🔥',
  'rocket-outline': '🚀', 'rocket': '🚀',
  'musical-notes-outline': '🎵', 'musical-notes': '🎵',
  'game-controller-outline': '🎮', 'game-controller': '🎮',
  'airplane-outline': '✈️', 'airplane': '✈️',
  'restaurant-outline': '🍽️', 'restaurant': '🍽️',
  'barbell-outline': '🏋️', 'barbell': '🏋️', 'fitness-outline': '🏋️', 'fitness': '🏋️',
  'gift-outline': '🎁', 'gift': '🎁',
  'cash-outline': '💰', 'cash': '💰',
  'bulb-outline': '💡', 'bulb': '💡',
  'checkbox-outline': '✅', 'checkbox': '✅', 'checkmark-circle-outline': '✅',
  'create-outline': '📝', 'create': '📝', 'pencil-outline': '📝',
  'cube-outline': '📦', 'cube': '📦',
  'construct-outline': '🔧', 'construct': '🔧', 'build-outline': '🔧',
  'trophy-outline': '🏆', 'trophy': '🏆',
  'happy-outline': '😊', 'happy': '😊',
  'paw-outline': '🐾', 'paw': '🐾',
  'leaf-outline': '🍃', 'leaf': '🍃',
  'cafe-outline': '☕', 'cafe': '☕',
  'camera-outline': '📷', 'camera': '📷',
  'car-outline': '🚗', 'car': '🚗',
  'school-outline': '🎓', 'school': '🎓',
  'sparkles': '✨', 'sparkles-outline': '✨',
};

/** An Ionicons name becomes an emoji; an emoji stays as it is. */
export const resolveIcon = (icon?: string): string => {
  if (!icon) return '\u{1F4CB}';
  // Any non-ASCII codepoint means it is already an emoji.
  if (/[^\x00-\x7F]/.test(icon)) return icon;
  return ICON_TO_EMOJI[icon] || '\u{1F4CB}';
};
